import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CompanyLinkFormValuesType } from '../../../../types';
import {
  BUSINESS_FIELDS_GRID_COL_SPAN,
  BUSINESS_FIELDS_TRANS_PATH,
} from '../../constants';

export const BuyerId: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Grid.Col span={BUSINESS_FIELDS_GRID_COL_SPAN}>
      <TextField<CompanyLinkFormValuesType>
        fieldName="buyerId"
        label={t(`${BUSINESS_FIELDS_TRANS_PATH}.BUYER_ID_LABEL`)}
      />
    </Grid.Col>
  );
};
